<template>
  <div class="inv-trans-info">
    <!-- <div class="title">{{ $t('p_invTransInfo_he_tong_xin_xi') }}</div> -->
    <div class="info-wrap">
      <div class="item-company">
        <div class="ub">
          <div class="ub-f1">
            <h1 class="sub-title">{{ $t('crm_inv_trans_info.chu_ku_fang_xin_xi') }}</h1>
            <ul>
              <li>
                <span class="label">{{ $t('crm_inv_trans_info.chu_ku_fang') }}</span>
                <span>{{ info.outOrgName }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_inv_trans_info.gong_si_di_zhi') }}</span>
                <span>{{ outCompanyAddress }}</span>
              </li>
            </ul>
          </div>
          <div class="ub-f1">
            <h1 class="sub-title">{{ $t('crm_inv_trans_info.ru_ku_fang_xin_xi') }}</h1>
            <ul>
              <li>
                <span class="label">{{ $t('crm_inv_trans_info.ru_ku_fang') }}</span>
                <span>{{ form.inOrgName }}</span>
              </li>
              <li>
                <div class="ub">
                  <div class="ub-f1">
                    <span class="label">{{ $t('crm_inv_trans_info.xiang_mu_fu_ze_ren') }}</span>
                    <span>{{ form.contactName }}</span>
                  </div>
                  <div class="ub-f1">
                    <span class="label">{{ $t('crm_inv_trans_info.lian_xi_dian_hua') }}</span>
                    <span>{{ form.contactPhone }}</span>
                  </div>
                </div>
              </li>
              <li>
                <span class="label">{{ $t('crm_inv_trans_info.gong_si_di_zhi') }}</span>
                <span>{{ inCompanyAddress }}</span>
              </li>
            </ul>
            <h1 class="sub-title" style="margin-top: 20px">{{ $t('crm_inv_trans_info.shou_huo_xin_xi') }}</h1>
            <ul>
              <li>
                <span class="label">{{ $t('crm_inv_trans_info.shou_huo_ren') }}</span>
                <span>{{ form.consigneeName }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_inv_trans_info.lian_xi_dian_hua') }}</span>
                <span>{{ form.consigneePhone }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_inv_trans_info.shou_huo_di_zhi') }}</span>
                <span>{{ receiveAddress }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="item-aftersale">
        <div class="ub">
          <div class="ub-f1">
            <h1 class="sub-title">{{ $t('crm_inv_trans_info.tiao_bo_xin_xi') }}</h1>
            <ul>
              <li>
                <span class="label">{{ $t('crm_inv_trans_info.sbsydz') }}</span>
                <span>{{ form.useLocation }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_inv_trans_info.tiao_bo_yuan_yin') }}</span>
                <span>{{ form.transferReason }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="info-lease">
        <h1 class="sub-title">{{ $t('crm_inv_trans_info.she_bei_xin_xi') }}</h1>
        <el-table :data="form.goodsList">
          <el-table-column :label="$t('crm_inv_trans_info.sbywlx')">
            <template slot-scope="scope">
              <custom-select code="dms_device_biz_type" v-model="scope.row.deviceBizType" :placeholder="$t('crm_inv_trans_info.sbywlx')" :disabled="true"></custom-select>
            </template>
          </el-table-column>
          <el-table-column :label="$t('crm_inv_trans_info.chan_pin_xing_hao')">
            <template slot-scope="scope">
              <custom-select url="productCodeSelectList" v-model="scope.row.productCode" :props="{ label: 'productName', value: 'productCode' }" :disabled="true"></custom-select>
            </template>
          </el-table-column>
          <el-table-column :label="$t('crm_inv_trans_info.chan_pinSN')">
            <template slot-scope="scope">
              <el-input v-model="scope.row.productSns" placeholder="" :disabled="true"></el-input>
            </template>
          </el-table-column>
          <el-table-column :label="$t('crm_inv_trans_info.shu_liang')" width="100">
            <template slot-scope="scope">
              {{ scope.row.bookingNum }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  components: {},
  name: '',
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
    rule: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    outCompanyAddress() {
      const outOrgInfo = this.info.outOrgInfo;
      return this.getAddress(outOrgInfo);
    },
    inCompanyAddress() {
      const inOrgInfo = this.info.inOrgInfo;
      return this.getAddress(inOrgInfo);
    },
    // 收货信息/收货地址
    receiveAddress() {
      const { detailAddress, country, province, city } = this.info;
      if (detailAddress) {
        const ret = [];
        if (country && province && city) {
          ret.push(country, province, city);
        }
        ret.push(detailAddress);
        return ret.join('');
      }
      return '-';
    },
  },
  data() {
    return {
      // 出库方列表
      outOrgList: [],
      form: {
        afterService: {
          detailAddress: '',

          // 下拉相关信息-提交表单
          deliverAddressId: '',
          version: '',

          // 下拉相关信息-界面显示
          consigneeName: '',
          consigneePhone: '',

          partnerOrgId: '',
        },

        // 调拨明细
        goodsList: [],

        // 出库方
        outOrgId: '',
        // 出库方组织名称
        outOrgName: '',
        outOrgCode: '',
        // 出库方详细地址信息
        outOrgAddressId: '',
        outOrgAddressVersion: '',
        // 授权代表公司地址 不需要提交  需要从select中获取
        outCompanyAddress: '',

        // 入库方名称
        inOrgName: '',
        inOrgId: '',
        inOrgCode: '',
        // 业务负责人
        contactName: '',
        // 联系电话
        contactPhone: '',
        // 入库方公司地址 不需要提交  从入库列表接口接口获取
        inCompanyAddress: '',
        // 收货人
        consigneeName: '',
        // 联系电话
        consigneePhone: '',
        // 收货地址
        detailAddress: '',
        // 收货地址下拉
        addressCode: [],

        // 设备使用地址
        useLocation: '',
        // 调拨原因
        transferReason: '',

        orderId: '',
        orderRemark: '',
        countryCode: '',
        provinceCode: '',
        cityCode: '',
      },
      info: {},
    };
  },
  mounted: function () {
    this.getPageInfo();
  },
  methods: {
    getAddress(info) {
      if (info) {
        if (info.address) {
          return info.address;
        } else {
          if (info.detailAddress) {
            const { country, province, city, detailAddress } = info;
            return [country, province, city, detailAddress].join('');
          }
        }
      }
      return '';
    },
    getPageInfo() {
      const orderId = this.getJump('changeId');
      this.$getJSON(apis.transferOrderInfo, {
        orderId: orderId,
      }).then((res) => {
        this.info = res.data;
        this.$setFormatData(this.form, res.data);
        if (res.data.countryCode) {
          this.form.addressCode.push(res.data.countryCode);
        }
        if (res.data.provinceCode) {
          this.form.addressCode.push(res.data.provinceCode);
        }
        if (res.data.cityCode) {
          this.form.addressCode.push(res.data.cityCode);
        }
        if (res.data.outOrgAddress) {
          const outOrgAddress = res.data.outOrgAddress;
          this.form.afterService.detailAddress = `${outOrgAddress.country}${outOrgAddress.province}${outOrgAddress.city}${outOrgAddress.detailAddress}`; // 详细地址;
          this.form.afterService.deliverAddressId = outOrgAddress.deliverAddressId;
          this.form.afterService.version = outOrgAddress.version;
          this.form.afterService.consigneeName = outOrgAddress.consigneeName;
          this.form.afterService.consigneePhone = outOrgAddress.consigneePhone;
          this.form.afterService.partnerOrgId = outOrgAddress.partnerOrgId;

          this.form.outOrgAddressId = outOrgAddress.deliverAddressId;
          this.form.outOrgAddressVersion = outOrgAddress.version;
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.inv-trans-info {
  background-color: #ffffff;
  .contract-scheme {
    > div {
      width: 180px;
      margin-bottom: 10px;
      > p:first-child {
        font-weight: 500;
        font-size: 12px;
      }
      p {
        line-height: 20px;
      }
    }
  }
  .pay-info {
    display: flex;
    justify-content: flex-end;
    line-height: 36px;
    color: #495057;
    font-size: 12px;
    font-weight: 500;
    margin-top: 10px;
    & > div {
      margin-left: 20px;
      margin-right: 10px;
      span {
        color: red;
        font-size: 14px;
      }
    }
  }
  .title {
    line-height: 50px;
    height: 50px;
    padding-left: 20px;
    color: $title-color;
    font-weight: bold;
    font-size: 14px;
    border-bottom: 1px solid #eef2f8;
  }
  .info-wrap {
    padding: 20px 24px;
    .sub-title {
      color: $title-color;
      font-size: 12px;
      line-height: 32px;
      font-weight: 500;
      margin-bottom: 4px;
    }
    .item-onfo {
      border-bottom: 1px solid #eef2f8;
      padding: 0 16px 12px;
      ul > li {
        width: 33.3%;
      }
    }
    .item-company {
      padding: 12px 16px;
      border-bottom: 1px solid #eef2f8;
      & > .ub > .ub-f1:first-child {
        padding-right: 20px;
        border-right: 1px solid #eef2f8;
        margin-right: 16px;
      }
    }
    .item-aftersale,
    .item-firstpay {
      padding: 12px 16px;
      border-bottom: 1px solid #eef2f8;
      & > .ub > .ub-f2 {
        padding-left: 48px;
      }
    }
    .info-lease {
      padding: 12px 16px;
    }
    .info-item {
      padding: 12px 16px;
      .el-upload-list {
        display: flex;
      }
      .el-upload-list__item {
        background: rgba(248, 249, 251, 1);
        line-height: 32px;
        height: 32px;
        color: #0d9ae0;
        width: 306px;
        border-radius: 2px;
        padding: 0 10px;
        margin-right: 14px;
        margin-top: 0;
        &:first-child {
          margin-top: 0;
        }
        i.el-icon-document {
          display: none;
        }
        a.el-upload-list__item-name {
          color: #0d9ae0;
        }
        i.el-icon-circle-check::before {
          color: #0d9ae0;
          font-family: 'icon';
          font-size: 12px;
          font-style: normal;
          margin-right: 4px;
          -webkit-font-smoothing: antialiased;
          content: '\e6ec';
        }
      }
    }
    ul > li {
      line-height: 23px;
      // height: 23px;
      color: #6c757d;
      font-size: 12px;
      .label {
        color: #495057;
        width: 120px;
        display: inline-block;
        vertical-align: top;
      }
      a {
        text-decoration: underline;
      }
    }
  }
}
</style>
